import React, {ReactNode} from "react";
import {css} from "@emotion/react";

import {getThemeVariable} from "@pg-design/styles-strings";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

interface IProps {
    label: string;
    showSubLabel: boolean;
    subLabel?: ReactNode;
}

export const SelectLabelWithEllipsis = (props: IProps) => {
    if (props.showSubLabel) {
        return (
            <span css={wrapperStyle}>
                {props.label} <br />
                <span css={subLabelWrapperStyle}>
                    {replaceSpaceWithNonBreakingSpace(" ")}
                    <span css={subLabelTextWrapper}>{props.subLabel}</span>
                </span>
            </span>
        );
    }

    return <React.Fragment>{props.label}</React.Fragment>;
};

const wrapperStyle = css`
    position: relative;
    display: block;
`;

const subLabelWrapperStyle = css`
    flex: 1 1 auto;
    font-size: ${getThemeVariable("globals.text.root")};
    color: ${getThemeVariable("colors.gray.700")};
`;

const subLabelTextWrapper = css`
    position: absolute;
    left: 0;
    right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
import React, {ReactNode} from "react";
import {css} from "@emotion/react";

import {getThemeVariable} from "@pg-design/styles-strings";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

interface IProps {
    label: string;
    showSubLabel: boolean;
    subLabel?: ReactNode;
}

export const SelectLabelWithEllipsis = (props: IProps) => {
    if (props.showSubLabel) {
        return (
            <span css={wrapperStyle}>
                {props.label} <br />
                <span css={subLabelWrapperStyle}>
                    {replaceSpaceWithNonBreakingSpace(" ")}
                    <span css={subLabelTextWrapper}>{props.subLabel}</span>
                </span>
            </span>
        );
    }

    return <React.Fragment>{props.label}</React.Fragment>;
};

const wrapperStyle = css`
    position: relative;
    display: block;
`;

const subLabelWrapperStyle = css`
    flex: 1 1 auto;
    font-size: ${getThemeVariable("globals.text.root")};
    color: ${getThemeVariable("colors.gray.700")};
`;

const subLabelTextWrapper = css`
    position: absolute;
    left: 0;
    right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
